import { createSelector } from 'reselect';

import { isMainSubscription } from 'helpers/subscriptions';

import { RootState } from 'types/store';

export const selectSubscriptions = (state: RootState) => state.subscriptions;

export const selectAllSubscriptions = createSelector(selectSubscriptions, ({ subscriptions }) => subscriptions);
export const selectDiscountSubscription = createSelector(
    selectSubscriptions,
    ({ discountSubscription }) => discountSubscription
);

export const selectCancellationCandidates = createSelector(
    selectSubscriptions,
    ({ cancellationCandidates }) => cancellationCandidates
);

export const selectMainSubscription = createSelector(selectAllSubscriptions, (subscriptions) =>
    subscriptions.find(({ product_type }) => isMainSubscription(product_type))
);

export const selectCancelReason = (state: RootState) => state.subscriptions.cancelReason;
